import {
    ChangeDetectorRef,
    Component,
    Inject,
    Input,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { ITableState, TableType } from '@soposopo/sopo-models';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/core/backend/api.service';
import { GameService } from 'src/app/core/firebase/game.service';
import { ProfileStateDispatcher } from 'src/app/core/state/profile/profile.dispatcher';
import { SopoLoadingService } from 'src/app/shared/services/sopo-loading/sopo-loading.service';
import { GameStateId } from 'src/app/core/state/game/game.state';
import { SOPO_DIALOG_DATA } from 'src/app/sopo-popup/interfaces/dialog';
import { DEFAULT_DISMISS_AFTER_TIME, SopoPopupService } from 'src/app/sopo-popup/service/sopo-popup.service';
import { SopoConfirmSettings } from 'src/app/sopo-popup/interfaces/confirm';

@Component({
    selector: 'app-ring-join-requests',
    templateUrl: './ring-join-requests.component.html',
    styleUrls: ['./ring-join-requests.component.scss'],
    standalone: false
})
export class RingJoinRequestsComponent implements OnInit, OnDestroy {
    tableId = '';
    isTableInfo = false;
    gameStateId = '';

    requestedRegistrations: string[] = [];
    acceptedRegistrationRequests: string[] = [];
    tableName = '';
    tournamentType = TableType.RING;
    clubId: string = '';
    gameServerUrl: string;

    private table: ITableState;
    private tableSubscription: Subscription;

    constructor(
        private ref: ChangeDetectorRef,
        private tableService: GameService,
        private profileService: ProfileStateDispatcher,
        private apiService: ApiService,
        private loadingService: SopoLoadingService,
        @Inject(SOPO_DIALOG_DATA) data: IRingJoinRequestsDialogData,
        private sopoPopupService: SopoPopupService,
    ) {
        if (data) {
            this.tableId = data.tableId;
            this.isTableInfo = data.isTableInfo;
            this.gameStateId = data.gameStateId;
        }
    }

    ngOnInit() {
        this.tableSubscription = this.tableService
            .getTableObservable(this.tableId)
            .subscribe((table: ITableState) => {
                if (table) {
                    this.table = table;
                    this.gameServerUrl =
                        this.table.server.state === 'Allocated'
                            ? ApiService.resolveGameServerUrl(this.table.server)
                            : '';
                    this.requestedRegistrations = this.table[
                        'joinToTableRequests'
                    ]
                        ? this.table['joinToTableRequests']
                        : [];
                    this.acceptedRegistrationRequests = this.table[
                        'acceptedJoinToTableRequests'
                    ]
                        ? this.table['acceptedJoinToTableRequests']
                        : [];
                    this.tableName = this.table.name;
                    this.clubId = this.table['clubID'];
                    this.ref.markForCheck();
                }
            });
    }

    async acceptAllRequsets() {
        if (this.requestedRegistrations.length == 0) return;

        const sopoConfirmSettings: SopoConfirmSettings = {
            data: {
                header: 'Accept All Requests',
                body: 'Do you want to accept all join request?',
                cancelText: 'No',
                okText: 'Yes',
            },
            sCss: !this.isTableInfo ? ['sopo-popup-red-background'] : [],
        };
        const result = await this.sopoPopupService.promptForConfirmation(
            !this.isTableInfo ? 'app' : 'game-container', 
            sopoConfirmSettings,
            !this.isTableInfo ? undefined : this.gameStateId, 
        );
        if (result) {
            if (this.checkConditions()) {
                this.callSocketFunction();
            } else {
                this.showAlert(
                    'Accept All Requests',
                    'Error occured! The reques was not sent.'
                );
            }
        }
    }
    
    checkConditions(): boolean {
        if (!this.clubId) {
            console.error(
                'Cannot accept all registration request without club id.'
            );
            return false;
        } else if (this.tableId === '') {
            console.error(
                'Cannot accept all registration request without table id.'
            );
            return false;
        } else {
            return true;
        }
    }

    async callSocketFunction() {
        const myId = await this.profileService.getMyID();
        if (this.gameServerUrl === '') {
            console.error('Game url not found');
            return;
        }
        this.loadingService.present('api');
        this.apiService
            .acceptAllTableJoin(
                {
                    tableID: this.tableId,
                    userID: '',
                    clubId: this.clubId,
                    myID: myId,
                },
                this.gameServerUrl
            )
            .then(
                (response) => {
                    this.showAlert(response.header, response.message);
                },
                (error) => {
                    const header = error.error.header
                        ? error.error.header
                        : 'Accept All Join Request';
                    const message = error.error.message
                        ? error.error.message
                        : 'Join accept failed';
                    this.showAlert(header, message);
                }
            )
            .finally(() => {
                this.loadingService.dismiss('api');
            });
    }

    async showAlert(header: string, message: string) {
        this.sopoPopupService.showAlert(
            !this.isTableInfo ? 'app' : 'game-container', 
            {
                header,
                message,
                dismissAfter: DEFAULT_DISMISS_AFTER_TIME,
                sCss: !this.isTableInfo ? ['sopo-popup-red-background'] : [],
            },
            !this.isTableInfo ? undefined : this.gameStateId, 
        );
    }

    ngOnDestroy(): void {
        if (this.tableSubscription) {
            this.tableSubscription.unsubscribe();
        }
    }
}

export interface IRingJoinRequestsDialogData {
    tableId: string;
    isTableInfo: boolean;
    gameStateId?: GameStateId;
}
